import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import type { ChavesDeApiState } from '../types/chavesDeApiTypes';
import {
  emissaoConcluida,
  emissaoIniciada,
  emissaoRecusada,
  listarChavesDeApi,
  revogarChaveDeApi,
} from './actions';

const initialState: ChavesDeApiState = {
  chaves: [],
  carregadoPara: null,
  listagemVigente: null,
  carregando: false,
  erro: null,
  acaoEmCurso: null,
  erroDaAcao: null,
};

const chavesDeApiSlice = createSlice({
  name: 'chavesDeApi',
  initialState,
  reducers: {
    limparErroDaAcao: (state) => {
      state.erroDaAcao = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarChavesDeApi.pending, (state, action) => {
        state.listagemVigente = action.meta.requestId;
        state.carregando = true;
        state.erro = null;
        // Outro escritório: a lista do anterior não pode ficar à vista enquanto a nova carrega.
        if (state.carregadoPara !== action.meta.arg) {
          state.chaves = [];
          state.carregadoPara = null;
        }
      })
      .addCase(listarChavesDeApi.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.listagemVigente) return;
        state.chaves = action.payload.chaves;
        state.carregadoPara = action.payload.escritorioId;
        state.carregando = false;
      })
      .addCase(listarChavesDeApi.rejected, (state, action) => {
        if (action.meta.requestId !== state.listagemVigente) return;
        state.carregando = false;
        state.erro = action.payload ?? {
          status: 0,
          codigo: null,
          mensagem: 'Não foi possível carregar as chaves.',
        };
      })
      .addCase(emissaoIniciada, (state, action) => {
        state.acaoEmCurso = action.payload;
        state.erroDaAcao = null;
      })
      .addCase(revogarChaveDeApi.pending, (state) => {
        state.acaoEmCurso = 'revogar';
        state.erroDaAcao = null;
      })
      .addMatcher(isAnyOf(emissaoConcluida, revogarChaveDeApi.fulfilled), (state) => {
        state.acaoEmCurso = null;
      })
      .addMatcher(isAnyOf(emissaoRecusada, revogarChaveDeApi.rejected), (state, action) => {
        state.acaoEmCurso = null;
        state.erroDaAcao = action.payload ?? {
          status: 0,
          codigo: null,
          mensagem: 'Não foi possível concluir a operação. Tente novamente.',
        };
      });
  },
});

export const { limparErroDaAcao } = chavesDeApiSlice.actions;
export const chavesDeApiReducer = chavesDeApiSlice.reducer;
